import { Map } from 'immutable';
import { SEER_DEMO } from '@constants/actions';
import { EMPTY_STRING } from '@constants/common';
import { LOCATION_CHANGE } from 'connected-react-router';

const initialState = Map({
  predictArticleId: EMPTY_STRING,
  isPredictionCompleted: false,
  predictionResult: {},
});

const SeerDemo = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case SEER_DEMO.REQUEST_SEER_PREDICTION:
      return state.set('predictArticleId', actionPayload);
    case SEER_DEMO.GET_SEER_PREDICTION_STATUS:
      return state.set('isPredictionCompleted', actionPayload);
    case SEER_DEMO.RETRIEVE_SEER_PREDICTION:
      return state.set('predictionResult', actionPayload);
    case SEER_DEMO.RESET:
    case LOCATION_CHANGE:
      return initialState;
    default:
      return state;
  }
};

export default SeerDemo;